// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {ShopScreenLayout} from 'app_components/screens/landing/shop'
// @end

// @ADD Component types
interface IShopScreenProps {}
interface IShopScreenState {}

class ShopScreen extends Component<IShopScreenProps, IShopScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  render() {
    return(
      <ShopScreenLayout/>
    )
  }
}

export default ShopScreen
